import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ConsentStore {
  consentToAnalytics: boolean;
  changeConsentToAnalytics: (newConsent: boolean) => void;
}

export const useConsentStore = create<ConsentStore>()(
  persist(
    (set) => ({
      consentToAnalytics: false,
      changeConsentToAnalytics: (newConsent) => {
        set(() => ({
          consentToAnalytics: newConsent,
        }));
      },
    }),
    {
      name: "consentOptions",
    },
  ),
);
